export default function Hero() {
  return (
    <div className="px-10 py-24 grid md:grid-cols-2 items-center gap-10">
      
      {/* LEFT SIDE */}
      <div>
        <p className="text-blue-600 font-medium mb-3">
          15-Minute Smart Service Booking
        </p>

        <h1 className="text-5xl md:text-6xl font-extrabold leading-tight text-gray-900">
          AI Smart Helper <br />
          Auto-Assignment & <br />
          Chatbot Booking System
        </h1>

        <p className="text-gray-600 mt-6 text-lg">
          Book plumbers, electricians, cleaners and more using simple
          chat. Our AI detects your request and automatically assigns
          the nearest available helper within seconds.
        </p>

        <div className="flex gap-4 mt-8">
          <button className="bg-blue-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition">
            Try Live Demo
          </button>

          <button className="border border-blue-600 text-blue-600 px-6 py-3 rounded-full font-semibold hover:bg-blue-50 transition">
            View Features
          </button>
        </div>
      </div>

      {/* RIGHT SIDE CHATBOT PREVIEW */}
      <div className="flex justify-center">
        <div className="bg-white shadow-2xl rounded-3xl w-96 overflow-hidden transform transition duration-500 hover:scale-105 hover:shadow-3xl">
          
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-4 font-semibold text-lg flex items-center gap-2">
            🤖 AI Booking Assistant
          </div>

          {/* Chat Body */}
          <div className="p-6 space-y-4 bg-gray-50 h-80">

            {/* User Message */}
            <div className="flex justify-end">
              <div className="bg-blue-600 text-white px-4 py-2 rounded-2xl max-w-xs text-sm shadow-md animate-fadeIn">
                Mujhe urgent plumber chahiye
              </div>
            </div>

            {/* Bot Message */}
            <div className="flex items-start gap-3 animate-fadeIn">
              <div className="bg-blue-500 text-white w-8 h-8 flex items-center justify-center rounded-full text-sm">
                🤖
              </div>
              <div className="bg-white px-4 py-2 rounded-2xl max-w-xs text-sm shadow-md border">
                Plumber assigned successfully ✅ <br />
                Estimated arrival:{" "}
                <span className="font-semibold text-blue-600">
                  12 mins
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
